import ExcellentExport from "excellentexport";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import ActionButton from "./action-button";
import ButtonsGroup from "./buttons-group";

export default function TablePanel<T>(props: {
  rows: T[];
  headers: React.ReactNode;
  footers?: React.ReactNode;
  lineLink?: (row: T) => string;
  lineColumns?: (row: T, index: number) => React.ReactNode;
  lineId?: (row: T) => string;
  reportBasename?: string;
}): React.ReactNode {
  const exportLinkRef = useRef<HTMLAnchorElement | null>(null);
  const tableRef = useRef<HTMLTableElement | null>(null);
  const navigate = useNavigate();

  const exportToFile = () => {
    if (!props.reportBasename) {
      return;
    }
    // https://github.com/jmaister/excellentexport
    // onclick="return ExcellentExport.convert({ anchor: this, filename: 'data_123.array', format: 'xlsx'},[{name: 'Sheet Name Here 1', from: {table: 'datatable'}}]);">Export to CSV</a>

    const exportLink = exportLinkRef.current!;
    const sourceTable = tableRef.current!;

    const exportTable = sourceTable.cloneNode(true) as HTMLTableElement;

    // Handle printing elements
    exportTable
      .querySelectorAll("[data-export]")
      .forEach((el) => el.replaceWith(el.getAttribute("data-export") ?? ""));

    // Blocking: colspan handling - https://github.com/jmaister/excellentexport/issues/686
    // ExcellentExport.convert(
    //   {
    //     anchor: exportLink,
    //     filename: `Cryptomedic ${props.reportBasename}`,
    //     format: "xlsx"
    //   },
    //   [{ name: "report", from: { table: exportTable } }]
    // );

    exportLink.setAttribute(
      "download",
      `Cryptomedic ${props.reportBasename}.xls`
    );

    ExcellentExport.excel(exportLink, exportTable, props.reportBasename);
    exportLink.click();
  };

  return (
    <>
      {props.lineLink && (
        <div style={{ textAlign: "center" }}>
          Click on a row to view details
        </div>
      )}
      {props.rows.length === 0 ? (
        <div className="alert alert-warning">No result found</div>
      ) : (
        <>
          {props.reportBasename && (
            <>
              <a ref={exportLinkRef} style={{ display: "none" }} />
              <ButtonsGroup align="end">
                <ActionButton
                  style="Alternate"
                  action="Export to Excel"
                  onOk={exportToFile}
                />
              </ButtonsGroup>
            </>
          )}
          {props.rows.length > 99 && (
            <div className="alert alert-info">
              Only the first 100 results are shown
            </div>
          )}
          <table
            ref={tableRef}
            className="table report-table"
            data-testid="report-table"
          >
            {props.headers}
            <tbody>
              {props.rows.map((row, index) => (
                <tr
                  key={
                    props.lineId
                      ? props.lineId(row)
                      : props.lineLink
                        ? props.lineLink(row)
                        : index
                  }
                  {...(props.lineLink && {
                    onClick: () => navigate(props.lineLink!(row))
                  })}
                  style={{
                    cursor: props.lineLink ? "pointer" : "default"
                  }}
                >
                  {props.lineLink && (
                    <td
                      onClick={(e) => {
                        const url = new URL(window.location.href);
                        url.pathname = props.lineLink!(row);
                        window.open(url.href, "_blank", "noopener");
                        e.stopPropagation();
                      }}
                    >
                      ↗
                    </td>
                  )}
                  {props.lineColumns
                    ? props.lineColumns(row, index)
                    : (row as React.ReactNode[])}
                </tr>
              ))}
            </tbody>
            {props.footers}
          </table>
        </>
      )}
    </>
  );
}
